module.exports = __webpack_public_path__ + "HRA Postcard - First Dollar.pdf";